import { render, staticRenderFns } from "./studentAndJob.vue?vue&type=template&id=1311cea8&scoped=true"
import script from "./studentAndJob.vue?vue&type=script&lang=js"
export * from "./studentAndJob.vue?vue&type=script&lang=js"
import style0 from "./studentAndJob.vue?vue&type=style&index=0&id=1311cea8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1311cea8",
  null
  
)

export default component.exports